// extracted by mini-css-extract-plugin
export var content = "styles-module--content--mM+Pf";
export var icons = "styles-module--icons--ibxff";
export var main = "styles-module--main--VvTAy";
export var ourStoryWrapper = "styles-module--ourStoryWrapper--pR5cS";
export var sidebar = "styles-module--sidebar--v0ZbB";
export var stat = "styles-module--stat--4F1ZM";
export var statValue = "styles-module--statValue--UAmcK";
export var subtitle = "styles-module--subtitle--3ra6x";